var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutUsBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1365,
    height: 768,
    viewBox: "0 0 1365 768",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3807_38270)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    y: -76,
    width: 1367,
    height: 614,
    fill: "url(#paint0_linear_3807_38270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 388C455.334 388 910.667 388 1366 388V768H0V388Z",
    fill: "url(#paint1_linear_3807_38270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 265.221H48.8305V396.649C52.3698 396.321 55.5764 395.935 58.4104 395.491V299.289H107.241V343.759C114.106 343.855 121.065 344.212 127.984 344.724V295.47H139.573V288.494C139.891 283.147 143.044 278.095 148.374 274.393C153.704 270.691 160.799 268.624 168.179 268.624C175.56 268.624 182.655 270.691 187.985 274.393C193.315 278.095 196.468 283.147 196.786 288.494V295.422H208.375V392.607H239.749V295.885H255.023V278.758H282.472V295.885H299.064V370.629C304.891 370.918 310.759 371.275 316.574 371.69V293.608H350.183L383.872 337.298V401.551C385.362 401.879 386.772 402.217 388.09 402.516V363.92H437V533.221H0V265.221Z",
    fill: "url(#paint2_linear_3807_38270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427 258.221H1378.17V389.649C1374.63 389.321 1371.42 388.935 1368.59 388.491V330.434H1319.76V343.221C1312.89 343.317 1305.93 343.674 1299.02 344.186V288.47H1287.43V281.494C1287.11 276.147 1283.96 271.095 1278.63 267.393C1273.3 263.691 1266.2 261.624 1258.82 261.624C1251.44 261.624 1244.35 263.691 1239.02 267.393C1233.69 271.095 1230.53 276.147 1230.21 281.494V288.422H1218.63V319.115H1187.25V288.885H1171.98V271.758H1144.53V288.885H1127.94V385.153C1122.11 385.442 1116.24 385.799 1110.43 386.214V286.608H1076.82L1043.13 330.298V394.551C1041.64 394.879 1040.23 395.217 1038.91 395.516V356.92H990V526.221H1427V258.221Z",
    fill: "url(#paint3_linear_3807_38270)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.381 416.073H339.525V466.906C340.864 467.196 342.124 467.496 343.305 467.808V432.761H387V611.22L-4 628.009V372.612H39.6954V417.697C42.8657 417.402 45.722 417.054 48.2643 416.654V408.78H91.9596V437.484C98.0997 437.576 97.4662 437.902 103.663 438.361V365.359H159.431V408.78H170.466V398.55H214.897V443.526H224.181V427.988H248.741V443.526H263.586V458.412C268.795 458.679 274.05 459.004 279.248 459.372V416.073H309.381ZM109.067 391.033V383.664H114.833V391.033H109.067ZM109.067 371.607V378.975H114.833V371.607H109.067ZM27.9718 385.353V377.985H33.7372V385.353H27.9718ZM203.372 416.955V424.324H209.137V416.955H203.372ZM203.372 412.936V405.567H209.137V412.936H203.372ZM119.026 371.607V378.975H124.791V371.607H119.026ZM76.2051 429.683V416.955H84.067V429.683H76.2051ZM284.271 447.1V454.468H290.036V447.1H284.271ZM293.705 441.741V434.372H299.47V441.741H293.705ZM284.271 434.372V441.741H290.036V434.372H284.271ZM284.271 429.683V422.314H290.036V429.683H284.271ZM293.705 422.314V429.683H299.471V422.314H293.705ZM302.615 429.683V422.314H308.381V429.683H302.615Z",
    fill: "url(#paint4_linear_3807_38270)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1070.61 419.853L1040.08 412.309V471.265C1038.73 471.558 1037.45 471.862 1036.25 472.177V436.732H992V600.241L1388 617.221V346.221H1343.75V466.793C1340.54 466.494 1337.64 466.143 1335.07 465.738V412.477H1290.81V460.725C1284.59 460.818 1266.49 461.147 1260.21 461.611V347.183H1207.64V402.131H1179.83V447.619H1156.9V431.905H1132.03V447.619H1116.99V462.674C1111.72 462.944 1106.39 463.273 1101.13 463.645V419.853H1070.61ZM1309.44 428.198V450.556H1299.88V428.198H1309.44ZM1218.91 372.214V364.761H1213.08V372.214H1218.91ZM1229 353.673V361.126H1223.16V353.673H1229ZM1361.46 369.933V362.481H1355.62V369.933H1361.46ZM1361.46 374.676V382.128H1355.62V374.676H1361.46ZM1190.53 416.681V409.228H1184.69V416.681H1190.53ZM1218.91 353.673V361.126H1213.08V353.673H1218.91ZM1321.65 441.071V428.198H1313.68V441.071H1321.65ZM1142.17 436.732V444.184H1136.33V436.732H1142.17ZM1200.37 416.681V409.228H1194.54V416.681H1200.37ZM1096.04 438.361V445.813H1090.2V438.361H1096.04ZM1096.04 433.618V426.166H1090.2V433.618H1096.04ZM1086.49 426.166V433.618H1080.65V426.166H1086.49ZM1051.35 433.618V426.166H1045.51V433.618H1051.35Z",
    fill: "url(#paint5_linear_3807_38270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.29 539.723C1142.66 528.475 1177.73 464.449 1316 464.449C1454.27 464.449 1409.27 558.67 1364.5 739.467H-11.4998C-18.9998 680.53 -75.7922 538.253 -21.1602 480.248C29.5503 426.407 119.803 495.9 263.068 495.9C406.333 495.9 420.834 540.349 666.873 544.106C861.588 547.078 895.383 546.61 989.29 539.723Z",
    fill: "url(#paint6_radial_3807_38270)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 669,
    cy: 396.5,
    rx: 936,
    ry: 243.5,
    fill: "url(#paint7_radial_3807_38270)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M0 548C272.5 548 471.291 574.471 671 574.894C888.87 575.356 1093 548 1366 548V768H0V548Z",
    fill: "url(#paint8_radial_3807_38270)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3807_38270",
    x1: 683,
    y1: -58,
    x2: 683.5,
    y2: 546.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0273305,
    stopColor: "#BEDCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49074,
    stopColor: "#FFFAE2",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3807_38270",
    x1: 668,
    y1: 388,
    x2: 670.535,
    y2: 1001.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.209826,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533196,
    stopColor: "#F9EFC2",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974464,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3807_38270",
    x1: -45.7424,
    y1: -121.66,
    x2: 460.323,
    y2: 310.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#230050",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3807_38270",
    x1: 1373.79,
    y1: -29.722,
    x2: 977.191,
    y2: 317.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#230050",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3807_38270",
    x1: -62.9611,
    y1: -210.794,
    x2: 404.978,
    y2: 519.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F0037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3807_38270",
    x1: 1351.95,
    y1: -53.9826,
    x2: 1027.98,
    y2: 551.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F0037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_3807_38270",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(682.125 719.043) rotate(90) scale(386.436 2269.28)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.393604,
    stopColor: "#FFFAE1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785217,
    stopColor: "#B6DAA5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_3807_38270",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(669 396.5) rotate(90) scale(329 1264.66)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_3807_38270",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(683 513.5) rotate(88.8227) scale(158.991 1159.38)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#E4CF8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4CF8A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3807_38270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 768,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsBg);
export default __webpack_public_path__ + "static/media/aboutUsBg.575a4e30362c3a97398f8899f2f2d1b2.svg";
export { ForwardRef as ReactComponent };